module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-preact/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-gatsby-cloud/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-image/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"background_color":"#3C00CF","display":"minimal-ui","icon":"src/images/favicon.png","name":"Tate.it","short_name":"Tate","start_url":"/","theme_color":"#3C00CF","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"dc18f05a37e7567546a9b355b2d63a59"},
    },{
      plugin: require('../node_modules/gatsby-plugin-google-gtag/gatsby-browser.js'),
      options: {"plugins":[],"gtagConfig":{"anonymize_ip":false,"cookie_domain":"auto","cookie_expires":63072000,"optimize_id":"OPT-K85CV4L","linker":{"accept_incoming":true,"domains":["scopri.tate.it"]}},"pluginConfig":{"head":false,"respectDNT":false},"trackingIds":["UA-66795751-3"]},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
